import { useEffect } from 'react';

/**
 * Auto reveal on scroll — attaches an IntersectionObserver to every element
 * carrying the class `.reveal`. When it enters the viewport, `.in` is added
 * so CSS transitions can play.
 */
export default function useScrollReveal(deps = []) {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window) || els.length === 0) {
      els.forEach((e) => e.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      // threshold 0 + bottom margin: a ratio threshold never fires early for
      // sections much taller than the viewport, leaving a blank screen.
      { threshold: 0, rootMargin: '0px 0px -15% 0px' }
    );
    els.forEach((e) => io.observe(e));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
